import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getFirestore, updateDoc, arrayUnion, setDoc, collection, getDocs, query, where, doc, getDoc, addDoc } from 'firebase/firestore';
import { db } from '../Firebase/Firebase';
import appFirebase from '../Firebase/Firebase';
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import WhatsAppButton from '../Components/whatsappbutton';
//CARRUECEL PRINCIPAL (RECOMENDADOS)
import Imagen1 from '../img/CarrucelImg1.png';
import Imagen2 from '../img/CarrucelImg2.png';
import Imagen3 from '../img/CarrucelImg3.png';
import Imagen4 from '../img/CarrucelImg4.png';
import Imagen5 from '../img/CarrucelImg5.png';
//CARRUECEL SECUNDARIO (MARCAS)
import Imagen6 from '../img/marca1.jpg';
import Imagen7 from '../img/marca2.jpg';
import Imagen8 from '../img/marca3.jpg';
import Imagen9 from '../img/marca4.jpg';
import Imagen10 from '../img/marca5.jpg';
import Imagen11 from '../img/marca6.jpg';
import Imagen12 from '../img/marca7.jpg';
import Imagen13 from '../img/marca8.jpg';
import SalaReuniones from '../img/SalaReuniones.png';
import SalaPrivada from '../img/SalaPrivada.png';
import SalaEquipos from '../img/SalaEquipos.png';
import Coworking from '../img/CarrucelImg3.png';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import emailjs from 'emailjs-com'; // Importar emailjs
import './home.css';
import DayPassImg from '../images/daypass.png';
import PrincipalHome from '../Components/home/principal';
import PopupEmergente from '../Components/iconosFlotantes/PopUpEmergente';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';
import EventosDestacadosWidget from '../Components/iconosFlotantes/EventosDestacadosWidget ';
import RecognitionCarousel from '../Components/home/Destacados';
function HomeLaOfi() {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [detenerAutomatico, setDetenerAutomatico] = useState(false);
    const [darkMode, setDarkMode] = useState(false);
    let temporizador = useRef(null);
 

    const [indiceActualCarrucel, setIndiceActualCarrucel] = useState(0); // Comienza en 0 (primera imagen)
    const handleAutoSignOut = () => {
        const auth = getAuth();
        const hasLoggedOut = sessionStorage.getItem("hasLoggedOut");
        if (!hasLoggedOut) {
            signOut(auth)
                .then(() => {
                    console.log("Sesión cerrada automáticamente.");
                    sessionStorage.setItem("hasLoggedOut", "true");
                })
                .catch((error) => {
                    console.error("Error al cerrar sesión:", error);
                });
        }
    };

    useEffect(() => {
        const isDark = document.body.classList.contains('dark-mode');
        setDarkMode(isDark);
    }, []);




    document.addEventListener('DOMContentLoaded', function () {
        const video = document.querySelector('.video-background');
        video.play().catch(error => {
            console.log('Reproducción automática bloqueada:', error);
        });
    });

    // Función para generar un ID único para invitados
    const generateGuestId = () => {
        return `Invitado_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    };

    // Función para obtener o generar un ID único para invitados
    const getGuestId = () => {
        const guestIdKey = "guestId";
        let guestId = sessionStorage.getItem(guestIdKey);
        if (!guestId) {
            guestId = generateGuestId();
            sessionStorage.setItem(guestIdKey, guestId);
        }
        return guestId;
    };

    const registrarClic = async (seccion, datosClic) => {
        const auth = getAuth();
        const user = auth.currentUser;

        // Obtener datos del usuario
        const nombreUsuario = user?.displayName || "Invitado";
        const [nombre, apellido = ""] = nombreUsuario.split(" ");
        const email = user?.email || "Sin email";
        const userId = user?.uid || getGuestId(); // Si no está autenticado, generar un ID único para el invitado

        // Referencia al documento del usuario en Firestore
        const userDocRef = doc(db, "Interacciones", userId);

        try {
            // Verificar si el documento del usuario ya existe
            const userDoc = await getDoc(userDocRef);

            if (!userDoc.exists()) {
                // Si no existe, crear un documento para el usuario
                await setDoc(userDocRef, {
                    nombre,
                    apellido,
                    email,
                    clics: {}, // Inicializar el mapa de clics
                });
            }

            // Obtener los datos existentes del usuario
            const userData = userDoc.exists() ? userDoc.data() : {};
            const clicsExistentes = userData.clics?.[seccion] || [];

            // Verificar si ya existe un clic para el mismo recomendado
            const clicExistente = clicsExistentes.find(clic => clic.idEspacio === datosClic.idEspacio);

            // Agregar fecha y hora al clic
            const fechaHora = new Date(); // Fecha y hora actual

            if (clicExistente) {
                // Incrementar el contador del clic existente
                clicExistente.contador = (clicExistente.contador || 1) + 1;
                clicExistente.fechaHora = fechaHora; // Actualizar la fecha y hora

                // Actualizar la sección en Firestore
                await updateDoc(userDocRef, {
                    [`clics.${seccion}`]: [
                        ...clicsExistentes.filter(clic => clic.idEspacio !== datosClic.idEspacio), // Mantener otros clics
                        clicExistente, // Reemplazar el actualizado
                    ],
                });
            } else {
                // Agregar un nuevo clic con contador inicializado y fechaHora
                datosClic.contador = 1;
                datosClic.fechaHora = fechaHora;

                await updateDoc(userDocRef, {
                    [`clics.${seccion}`]: arrayUnion(datosClic),
                });
            }

            console.log(`Clic registrado en la sección "${seccion}" para el usuario:`, datosClic);
        } catch (error) {
            console.error("Error al registrar clic:", error);
        }
    };





    const handleClick = async (seccion, titulo, idEspacio) => {
        const datosClic = {
            titulo,
            idEspacio,
            timestamp: new Date().toISOString(), // Agregar marca de tiempo
        };

        try {
            await registrarClic(seccion, datosClic);
            navigate(`/tipos_espacios/${idEspacio}`);
        } catch (error) {
            console.error("Error al registrar clic:", error);
        }
    };

    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        {
            title: "Salas de Reuniones",
            subtitle: (
                <>
                    <ul className="separating-list">
                        <li>Reuniones de equipo o con clientes.</li>
                    </ul>
                </>
            ),
            buttonAction: () => handleClick("TiposEspacios", "Salas de Reuniones", "58jGMk4PIkMe5X6ru1hk"),
            image: SalaReuniones,
            className: "carousel-slide carousel-slide1",
        },
        {
            title: "Oficinas Privadas",
            subtitle: (
                <>
                    <ul className="separating-list">
                        <li>Reuniones privadas y cómodas.</li>
                    </ul>
                </>
            ),
            buttonAction: () => handleClick("TiposEspacios", "Oficinas Privadas", "fKlrgkAvhYESaPuB9y9V"),
            image: SalaPrivada,
            className: "carousel-slide carousel-slide2",
        },
        {
            title: "Oficinas para Equipos",
            subtitle: (
                <>
                    <ul className="separating-list">
                        <li>Espacios para equipos.</li>
                    </ul>
                </>
            ),
            buttonAction: () => handleClick("TiposEspacios", "Oficinas para Equipos", "D5KZfPn43Qow76QEq9oY"),
            image: SalaEquipos,
            className: "carousel-slide carousel-slide3",
        },
        {
            title: "Coworking",
            subtitle: (
                <>
                    <ul className="separating-list">
                        <li>Espacios colaborativos para freelancers.</li>
                    </ul>
                </>
            ),
            buttonAction: () => handleClick("TiposEspacios", "Coworking", "tipoEspacio_pvozqd0m4"),
            image: Coworking,
            className: "carousel-slide carousel-slide5",
        },
    ];


    // Función para avanzar a la siguiente slide
    const nextSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
    };

    // Función para retroceder a la anterior slide
    const prevSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
    };

    // Obtener las 3 slides visibles
    const getVisibleSlides = () => {
        const visibleSlides = [];
        for (let i = 0; i < 3; i++) {
            const slideIndex = (currentSlide + i) % slides.length;
            visibleSlides.push(slides[slideIndex]);
        }
        return visibleSlides;
    };
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false); // Modal de confirmación
    const [providerForm, setProviderForm] = useState({
        companyName: '',
        ruc: '',
        phone_em: '',
        city: '',
        sector: '',
        parish: '',
        mainStreet: '',
        secondaryStreet: '',
        number_em: '',
        postalCode: '',
        reference: '',
    });
    const [errors, setErrors] = useState({});

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);  // Alterna la visibilidad del modal
    };

    const handleProviderChange = (e) => {
        const { id, value } = e.target;
        setProviderForm({
            ...providerForm,
            [id]: value,
        });
    };

    const handleProviderSubmit = (e) => {
        e.preventDefault();
        // Aquí agregarás la lógica para manejar la sumisión del formulario
        console.log(providerForm);
    };

    const imagenesCarrucelNuevo = [
        { src: Imagen6, url: "https://www.instagram.com/laofi.work/" },
        { src: Imagen7, url: "https://www.instagram.com/logokimia/" },
        { src: Imagen8, url: "https://www.instagram.com/cima_consulting/" },
        { src: Imagen9, url: "https://www.instagram.com/aso.ecuador.emprendedor/" },
        { src: Imagen10, url: "https://www.instagram.com/happybuho/" },
        { src: Imagen11, url: "https://www.instagram.com/romeosjulietas/" },
        { src: Imagen12, url: "https://www.instagram.com/skala_tunegocio/" },
        { src: Imagen13, url: "https://www.instagram.com/lexy.app/" },
    ];

    const [indiceActual, setIndiceActual] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);

    const avanzar = () => {
        setIndiceActual((prev) => (prev + 1) % imagenesCarrucelNuevo.length);
    };

    const retroceder = () => {
        setIndiceActual((prev) =>
            prev === 0 ? imagenesCarrucelNuevo.length - 1 : prev - 1
        );
    };

    const visibleImages = 7; // Número de imágenes visibles al mismo tiempo

    const imagenesVisibles = [
        ...imagenesCarrucelNuevo,
        ...imagenesCarrucelNuevo, // Duplicado para continuidad
    ].slice(indiceActual, indiceActual + visibleImages);

    // Manejo del toque para deslizar el carrusel
    const handleTouchStart2 = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchEnd2 = () => {
        if (touchStartX - touchEndX > 100) {
            avanzar(); // Deslizar a la derecha
        } else if (touchEndX - touchStartX > 100) {
            retroceder(); // Deslizar a la izquierda
        }
    };

    const handleTouchMove2 = (e) => {
        setTouchEndX(e.touches[0].clientX);
    };

    // Hacer que el carrusel se mueva automáticamente
    useEffect(() => {
        const interval = setInterval(() => {
            avanzar();
        }, 3000); // Cambia cada 3 segundos

        // Limpiar el intervalo cuando el componente se desmonte
        return () => clearInterval(interval);
    }, []);


    const toggleConfirmationModal = () => {
        setIsConfirmationModalOpen(!isConfirmationModalOpen); // Abre o cierra el modal de confirmación
    };


    const sendProviderEmail = (providerDetails) => {
        const message = [
            `Nombre de la empresa: ${providerDetails.companyName}`,
            `RUC: ${providerDetails.ruc}`,
            `Teléfono: ${providerDetails.phone_em}`,
            `Ciudad: ${providerDetails.city}`,
            `Sector: ${providerDetails.sector}`,
            `Parroquia: ${providerDetails.parish}`,
            `Calle principal: ${providerDetails.mainStreet}`,
            `Calle secundaria: ${providerDetails.secondaryStreet}`,
            `Número de teléfono/em: ${providerDetails.number_em}`,
            `Código postal: ${providerDetails.postalCode}`,
            `Referencia: ${providerDetails.reference}`
        ].join('\n');  // Unir todos los elementos del array en un solo string, separado por saltos de línea

        // Enviar el mensaje usando emailjs
        emailjs.send(
            'service_weot8z6', // Reemplaza con tu service ID
            'template_6p6g49j', // Reemplaza con tu template ID
            { message },
            'rQVGkHAuA0UsUrEo9' // Reemplaza con tu user ID de EmailJS  
        )
            .then((response) => {
                console.log('Correo enviado exitosamente', response);

                // Cierra el modal de formulario
                setIsModalOpen(false);

                // Muestra el modal de confirmación
                setIsConfirmationModalOpen(true);
            })
            .catch((error) => {
                console.error('Error al enviar el correo', error);
            });
    };
    const [isDarkMode, setIsDarkMode] = useState(() => {
        try {
            // Intentamos leer valor guardado en localStorage
            const saved = localStorage.getItem('darkMode');
            if (saved !== null) {
                const parsed = JSON.parse(saved);
                if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
            }
        } catch (error) {
            // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
            console.warn('Error leyendo localStorage darkMode:', error);
        }

        // Detectar modo oscuro sistema solo si está disponible window.matchMedia
        const prefersDark = typeof window !== 'undefined' && window.matchMedia
            ? window.matchMedia('(prefers-color-scheme: dark)').matches
            : false;

        // Detectar hora nocturna (7pm a 6am)
        const hour = new Date().getHours();
        const isNight = hour >= 19 || hour < 6;

        // Retorna true o false seguro
        return prefersDark || isNight;
    });

    // Cargar el tema al inicio (localStorage, sistema u hora)
    useEffect(() => {
        const savedTheme = localStorage.getItem('darkMode');
        if (savedTheme !== null) {
            setIsDarkMode(JSON.parse(savedTheme));
        } else {
            // Detecta modo oscuro sistema
            const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

            // Detecta modo oscuro por hora (7pm - 6am)
            const hour = new Date().getHours();
            const isNight = hour >= 19 || hour < 6;

            setIsDarkMode(prefersDark || isNight);
        }
    }, []);

    // Guardar la preferencia y aplicar clase al body
    useEffect(() => {
        localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
        document.body.classList.toggle('dark-mode', isDarkMode);
    }, [isDarkMode]);

    // Función para cambiar el modo
    const toggleDarkMode = () => setIsDarkMode(!isDarkMode);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [mostrarPopup, setMostrarPopup] = useState(false);

    useEffect(() => {
        const auth = getAuth(appFirebase);
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                // Usuario logueado
                setIsLoggedIn(true);
                setMostrarPopup(false);
            } else {
                // No logueado
                setIsLoggedIn(false);
                setMostrarPopup(true);
            }
        });

        // Cleanup al desmontar
        return () => unsubscribe();


    }, []);
    const handleCerrarPopup = () => {
        console.log("Cerrando popup...");
        setMostrarPopup(false);
    };

    return (
        <>
            <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode}/>

            <div className='contenedor-home' >
                <WhatsAppButton />
                <PrincipalHome />
                <EventosDestacadosWidget />

                
                <div className='body-principal-home'>
                   

                    <div className='marcas'>
                        <h2>
                            Califícanos en Google
                        </h2>
                    </div>
                    <br />
                    <div class="calificanos-container">
                        <div class="calificanos-left">
                            <a href="https://g.page/r/CeAscuOdzqRsEBI/review" target="_blank">
                                {/*<img src={DayPassImg} alt="Estrellas de calificación" />*/

                                }

                            </a></div>

                        <div class="calificanos-right">
                            <h2>¡Queremos saber tu opinión!</h2>
                            <p>Si te gustó nuestro servicio, califícanos en Google. ¡Tu opinión nos ayuda a crecer!</p>
                            <p>Además gana un Pack de 8 horas en nuestros espacios <span>(Válido por 7 días)</span></p>

                            <a href="https://g.page/r/CeEAscuOdzqRsEBI/review" target="_blank">Califícanos en Google</a>
                        </div>
                    </div>
                    <div className='marcas'>
                        <h2>
                            NUESTRAS MARCAS
                        </h2>
                    </div>
                    <div className="carrusel-contenedor-principal">
                        <div className="carrusel">
                            <div
                                className="carrusel-contenedor"
                                onTouchStart={handleTouchStart2}
                                onTouchMove={handleTouchMove2}
                                onTouchEnd={handleTouchEnd2}
                            >
                                {imagenesVisibles.map((imagen, index) => (
                                    <img
                                        key={index}
                                        src={imagen.src}
                                        alt={`Imagen ${indiceActual + index + 1}`}
                                        className="imagen-carrusel"
                                        onClick={() => window.location.href = imagen.url}
                                    />
                                ))}
                            </div>
                        </div>
                    </div></div>


                {isModalOpen && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div className="modal-prov" onClick={toggleModal}> {/* Cierra el modal si se hace clic fuera */}
                                <div className="modal-content-prov" onClick={(e) => e.stopPropagation()}>

                                    {/* Encabezado con título y botón de cierre */}
                                    <div className="modal-header">
                                        <button className="btn-close" onClick={toggleModal}>✖</button>
                                        <h4 className='titulo_form_prov'>Información para ser Anfitrión</h4>
                                    </div>

                                    <div className="modal-body">
                                        <form className='form_n_prov' onSubmit={handleProviderSubmit}>
                                            {[
                                                { id: "companyName", label: "Razón Social" },
                                                { id: "ruc", label: "RUC" },
                                                { id: "phone_em", label: "Teléfono" },
                                                { id: "city", label: "Ciudad" },
                                                { id: "sector", label: "Sector" },
                                                { id: "parish", label: "Parroquia" },
                                                { id: "mainStreet", label: "Calle Principal" },
                                                { id: "secondaryStreet", label: "Calle Secundaria" },
                                                { id: "number_em", label: "Número" },
                                                { id: "postalCode", label: "Código Postal" }
                                            ].map(({ id, label }) => (
                                                <div key={id} className="input-group">
                                                    <input id={id} placeholder=" " value={providerForm[id]} onChange={handleProviderChange} required />
                                                    <label htmlFor={id}>{label}</label>
                                                    {errors[id] && <p className="error-message">{errors[id]}</p>}
                                                </div>
                                            ))}

                                            <div className="input-group">
                                                <textarea id="reference" placeholder=" " value={providerForm.reference} onChange={handleProviderChange} required />
                                                <label htmlFor="reference">Referencia</label>
                                                {errors.reference && <p className="error-message">{errors.reference}</p>}
                                            </div>

                                            {/* Botón de guardar */}
                                            <div className="button-group">
                                                <button type="submit" className="btn-submit" onClick={sendProviderEmail}>Guardar</button>
                                            </div>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {isConfirmationModalOpen && (
                    <div className="modal-prov">
                        <div className="modal-content-prov">
                            <h4 className="titulo_form_prov">¡Gracias por tu información!</h4>
                            <p>Un administrador se contactará contigo pronto.</p>
                            <div className="button-modal-conf-prov">
                                <button type="button" onClick={toggleConfirmationModal} className="btn-close-modal">
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <Footer />
            </div> </>



    );
}

export default HomeLaOfi;